import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControlLabel, Checkbox } from "@mui/material";

import { APIFunds } from "../../../../api";
import { fundedTraderActions } from "../../../../reducers/fundedTrader";

const ProfessionalLiveSimData = (): React.ReactElement | null => {
  const dispatch = useDispatch();

  const { accounts_id, is_professional_live_sim, isLoading } = useSelector(
    (state) => state.fundedTrader
  );

  const handleChangeLiveSimProfessionalStatus = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      dispatch(fundedTraderActions.dataFetchRequest());
      const response = await APIFunds.updateFundedTraderDataRequest(accounts_id, {
        is_professional_live_sim: event.target.checked,
      });
      dispatch(fundedTraderActions.dataFetchSuccess(response.data));
    } catch (error) {
      console.error("Error handle update liveSim professional status", error);
      dispatch(fundedTraderActions.dataFetchFailed());
    }
  };

  if (isLoading) {
    return null;
  }

  return (
    <div>
      <FormControlLabel
        label="Pro trader in Rithmic"
        control={
          <Checkbox
            size="small"
            disabled={isLoading}
            onChange={handleChangeLiveSimProfessionalStatus}
            checked={is_professional_live_sim}
            name="Pro trader in Rithmic"
          />
        }
      />
    </div>
  );
};

export default ProfessionalLiveSimData;
